import cn from "@/helpers/classNames";

function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function HighlightedText(props: {
  highlighted: string;
  text: string;
  lineThrough?: boolean;
}) {
  const escapedHighlighted = escapeRegExp(props.highlighted);
  const matches = props.text.match(
    new RegExp(`(.*)(${escapedHighlighted})(.*)`),
  );

  if (!props.highlighted || !Array.isArray(matches)) {
    return (
      <span className={cn({ "line-through": props.lineThrough })}>
        {props.text}
      </span>
    );
  }

  return (
    <span className={cn({ "line-through": props.lineThrough })}>
      <span>{matches[1]}</span>
      <span className="bg-yellow-300 dark:bg-yellow-700">{matches[2]}</span>
      <span>{matches[3]}</span>
    </span>
  );
}
